<template>
  <div class="hot-news-list card-shadow">
    <h1>
      <span class="red-border">{{ title }}</span>
    </h1>
    <div
      class="hot-news-item can-click"
      v-for="(item, index) in news"
      :key="index"
      @click="viewNews(item)"
    >
      <span class="name">{{ item.title }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "hotNews",
  props: {
    title: {
      type: String,
    },
    news: {
      type: Array,
      required: true,
      default: function () {
        return [];
      },
    },
  },
  created() {
    console.log(this.title);
  },
  methods: {
    viewNews(item) {
      this.$router.push(`./${item.id}`);
    },
  },
};
</script>

<style scoped>
.hot-news-list {
  padding: 30px 20px;
  background-color: #fff;
  border: 1px solid #eee;
  margin-top: 36px;
  margin-left: 20px;
  width: 25vw;
}

.hot-news-list h1 {
  height: 34px;
  font-size: 18px;
  line-height: 26px;
  color: #111111;
  border-bottom: 1px solid #d8d8d8;
}

h1 .red-border {
  display: inline-block;
  height: 100%;
  border-bottom: 1px solid #c0392c;
}

.tjxd h1 .red-border {
  border-color: #ec2f08;
}

.hot-news-item {
  position: relative;
  margin-top: 30px;
  padding-left: 16px;
  font-size: 14px;
  line-height: 22px;
}

.hot-news-item::before {
  content: "";
  position: absolute;
  top: 8px;
  left: 0;
  display: block;
  width: 6px;
  height: 6px;
  background-color: #c0392c;
  border-radius: 100%;
}

.tjxd .hot-news-item::before {
  background-color: #ec2f08;
}
</style>
